import { isloggedinService } from 'api/services/user/isloggedin';
import api, { updateDefaults, getExecute } from 'services/api/microfwk';
import apiSticky, { updateDefaultsSticky } from 'services/api/microfwkSticky';
import qs from 'qs';
import _ from 'lodash';
import {
  setProfileLastTouch,
  setProfileLastTouchFavorited,
} from 'utils/Socialization';
import { apiCall, updateSwaggerManager } from 'api';
import { SERVICES_USER_REGISTER_PATH_SERVICES, USER_LOGIN_PATH_SERVICE } from 'api/services/content/paths';
import { HttpClient } from 'api/helpers/HttpClient';
import { getRegion } from 'reducers/response';
import { getSuperHighlightService } from 'api/services/user';
import { store } from '../../store';
import { getHKS, setHKS } from '../../utils/HKS';
import { setRegion } from '../../utils/Region';
import { setUserToken } from 'action-creators/user';
import { removeTokenUserAnonymous, setTokenUserAnonymous } from 'utils/user/anonymousLocalStoreUser';

const configPost = {
  headers: {
    'content-type': 'application/x-www-form-urlencoded',
  },
};

export const setDefaultParams = (params = {}) => {
  const parameters = Object.assign({}, params);
  setHKS(parameters.HKS);
  updateSwaggerManager(apiCall, { ...parameters });
  updateDefaults(api, { params: parameters });
  delete parameters.user_id;
  updateDefaultsSticky(apiSticky, { params: parameters });
};

export const getUserLogInSSO = body =>
  api
    .post('services/user/loginsso', qs.stringify(body), { ...configPost })
    .then(({ data }) => data);

export const userLogin = (request = {}) => {
  const { body, params } = request;
  const formData = new FormData();
  Object.keys(body).map(key => {
    formData.append(key, body[key]);
    return key;
  });
  return apiCall
    .post(USER_LOGIN_PATH_SERVICE, formData, { params })
    .then(({ data } = {}) => {
      if (!data.data) return {};

      let responseValues;
      const user_token = data?.data?.user_token
      updateSwaggerManager(apiCall, { user_token });
      apiCall.defaults.headers['Authorization'] = `Bearer ${user_token}`;
      apiCall.defaults.headers['user-token'] = `Bearer ${user_token}`;
      
      if (data?.data) {
        responseValues = {
          msg: 'OK',
          response: data.data,
          status: '0',
        };
      } else responseValues = data;

      const {
        region,
        session_stringvalue: hks,
        user_id: userId,
      } = responseValues?.response;

      const parameters = {};
      if (hks) parameters.HKS = hks;
      if (userId) parameters.user_id = userId;
      if (region) setRegion(region);
      setDefaultParams(parameters);

      return responseValues;
    })
    .catch(error => {
      const data = _.get(error, 'response.data', false);
      if (data?.errors) return data;

      if (
        !data?.response?.session_stringvalue &&
        !data?.response?.user_id &&
        !data?.response?.region
      )
        return data;

      const {
        region,
        session_stringvalue: hks,
        user_id: userId,
      } = data.response;

      const parameters = {};
      if (hks) parameters.HKS = hks;
      if (userId) parameters.user_id = userId;
      if (region) setRegion(region);

      updateSwaggerManager(apiCall, { HKS: hks, region });
      setDefaultParams(parameters);

      return data;
    });
};

export const getUserRegister = (formData) =>
  apiCall
    .post(SERVICES_USER_REGISTER_PATH_SERVICES, formData, { params: {HKS: null, user_token: null}})
    .then(response => {

      if (!response?.data?.data) return {};
      const { session_stringvalue: hks } = response?.data?.data;
      const userId = response?.data?.data?.user_id;
      if (hks) {
        const qParams = {
          HKS: hks,
        };
        if (userId) {
          qParams.user_id = userId;
        }
        setDefaultParams(qParams);
      }
      return response;
    })
    .catch(error =>{
      throw error?.response;
    });

export const getUserIsLoggendin = async (params = {}) =>
  isloggedinService(params)
    .then(async response => {
      const { data } = response;
      const dataTransformed = data || response?.response?.data;
      if (!dataTransformed?.data) return {};
      if (!dataTransformed?.data && dataTransformed?.errors)
        throw dataTransformed;

      const {
        session_stringvalue: hks,
        user_id: userId,
        user_token,
        region,
        lasttouch,
      } = dataTransformed.data;

      const parameters = {};
      if (region) {
        parameters.region = region;
        setRegion(region);
      }
      if (hks) parameters.HKS = hks;
      if (userId) parameters.user_id = userId;

      setDefaultParams(parameters);
       updateSwaggerManager(apiCall, { user_token });
       apiCall.defaults.headers['Authorization'] = `Bearer ${user_token}`;
       apiCall.defaults.headers['user-token'] = `Bearer ${user_token}`;
       store.dispatch(setUserToken(user_token));
       removeTokenUserAnonymous()

      if (lasttouch) {
        if (lasttouch.profile) setProfileLastTouch(lasttouch.profile);
        if (lasttouch.favorited)
          setProfileLastTouchFavorited(lasttouch.favorited);
      }
      if (lasttouch.seen) {
        localStorage.setItem('lasttouchSeen', lasttouch.seen);
      }

     try {
          const { data: superHighlightData } = await getSuperHighlightService({
            claroLiteConfig: params?.claroLiteConfig,
          });

        return {
          response: {
            ...data.data,
            is_user_logged_in: '1',
            superhighlight: superHighlightData.data.superhighlight,
          },
          status: '0',
        };
     } catch (error) {
       throw dataTransformed;
     }

    })
    .catch( async (error) => {
      let superHighlightData = {}

      const data =
        _.get(error, 'response.data', false) || {
          response: error?.data,
          ...error,
        } ||
        false;


      if (
        error?.errors?.code === 'USR_USR_00001' ||
        data?.errors?.code === 'USR_USR_00001'
      ){
        apiCall.defaults.headers['Authorization'] = `Bearer ${data?.data?.user_token ||  error?.data?.user_token}`;
        apiCall.defaults.headers['user-token'] = `Bearer ${data?.data?.user_token ||  error?.data?.user_token}`;
          updateSwaggerManager(apiCall, {
            user_token: data?.data?.user_token ||  error?.data?.user_token,
          });

          try {
            const token =  data?.data?.user_token ||  error?.data?.user_token;
            await setTokenUserAnonymous(token)
          } catch (error) {
            console.log('ERROR en el token de usr anonimo',error)
          }

          try {
            const { data: highlightResponse } = await getSuperHighlightService({});
            superHighlightData = highlightResponse;
          } catch (error) {
            console.log('ERROR getSuperHighlightService')
          }

      }


      if (data?.errors?.code !== 'accept_terms') return {...data, superhighlight: superHighlightData?.data?.superhighlight };

      if (
        !data?.response?.session_stringvalue &&
        !data?.response?.user_id &&
        !data?.response?.region
      )
        return {};

      const {
        session_stringvalue: hks,
        user_id: userId,
        user_token,
        region,
        lasttouch,
      } = data.response;
      const parameters = {};
      if (region) {
        parameters.region = region;
        setRegion(region);
      }
      if (hks) parameters.HKS = hks;
      if (userId) parameters.user_id = userId;

      updateSwaggerManager(apiCall, { HKS: hks, user_token });
      setDefaultParams(parameters);

      if (lasttouch) {
        if (lasttouch.profile) setProfileLastTouch(lasttouch.profile);
        if (lasttouch.favorited)
          setProfileLastTouchFavorited(lasttouch.favorited);
      }
      if (lasttouch.seen) {
        localStorage.setItem('lasttouchSeen', lasttouch.seen);
      }
      return { ...data, response: { ...data.response, is_user_logged_in: '1', superhighlight: superHighlightData?.data?.superhighlight } };
    });

export const getEpgMenu = (params = {}) =>
  api.get('services/epg/menu', { params }).then(({ data }) => data);

export const getEpgVersion = (params = {}) => {
  const loggedUserData = localStorage.getItem('loginInfo.logged_user_data');
  const { subregion } = loggedUserData ? JSON.parse(loggedUserData) : {};
  const newParams = subregion ? { ...params, subregion } : params;

  return getExecute('services/epg/version', newParams);
};

export const getUserModify = params =>
  api.get('services/user/modify', { params }).then(({ data }) => data);

export const getUserLogin = (params = {}) => {
  // eslint-disable-next-line no-param-reassign
  params.user_id = null;

  return apiCall
    .post(USER_LOGIN_PATH_SERVICE,{}, { params })
    .then(({ data }) => {
      if (!data.data) return {};
      const {
        region,
        session_stringvalue: hks,
        user_id: userId,
        lasttouch,
      } = data.data
      if (region) {
        setRegion(region);
      }
      const parameters = {};
      if (hks) parameters.HKS = hks;
      if (userId) parameters.user_id = userId;

      setDefaultParams(parameters);

      if (lasttouch) {
        if (lasttouch.profile) setProfileLastTouch(lasttouch.profile);
        if (lasttouch.favorited)
          setProfileLastTouchFavorited(lasttouch.favorited);
      }
      return { response: data?.data }
    })
    .catch(error => {
      const data = _.get(error, 'response.data', false);

      if (!data) return error;

      const {
        region,
        session_stringvalue: hks,
        user_id: userId,
      } = data.response;

      if (region) setRegion(region);

      const parameters = {};
      if (hks) parameters.HKS = hks;
      if (userId) parameters.user_id = userId;

      updateSwaggerManager(apiCall, { HKS: hks, region });
      setDefaultParams(parameters);

      return data;
    });
};

export const isLoggedin = params =>
  api.get('services/user/sociallogin', { params }).then(({ data }) => {
    if (!data || (!data.response && !data.errors)) return {};
    const hks = data.response && data.response.session_stringvalue;
    if (hks) {
      setDefaultParams({
        HKS: hks,
      });
    }
    return data;
  });

export const pushSession = (params = {}, body = {}) => {
  const region = localStorage.getItem('loginInfo.region');
  const parameters = {
    HKS: getHKS(),
    user_id: params.user_id,
  };

  setDefaultParams(parameters);
  return apiSticky.post(
    `services/user/push_session?user_id=${params.user_id}`,
    qs.stringify(body),
    { params: { region }, ...configPost },
  );
};

export const getPaywayProfile = params =>
  api.get('services/payway/profile', { params }).then(({ data }) => data);
